import { API } from "revolt.js";

import { modalController } from "../../../../controllers/modals/ModalController";
import { ImageLike } from "../../../../controllers/modals/types";

export function selectImageViewer(
    allEmbeds: ImageLike[] | null | undefined,
    currentEmbed: ImageLike,
) {
    const images = allEmbeds?.filter(isImageLike);
    const startIndex = images?.indexOf(currentEmbed);
    if (images && startIndex !== -1) {
        modalController.push({
            type: "image_viewer_gallery",
            images,
            startImage: startIndex,
        });
    } else if (isImageLike(currentEmbed)) {
        modalController.push({ type: "image_viewer", image: currentEmbed });
    }
}

function isImageLike(imLike: unknown): imLike is ImageLike {
    if (!imLike) {
        return false;
    }

    if ((imLike as API.Embed).type === "Image") {
        return true;
    }

    return (imLike as any).metadata?.type === "Image";
}
